import { FC } from 'react'

import { Configuration } from '../../redux/configuration'
import { AppContainer, FakePhone } from '../../styles/global'
import HomeSkeleton from '../../views/Home/HomeSkeleton'

interface IWebviewContainerProps {
  configuration: Configuration | null
}

const WebviewContainer: FC<IWebviewContainerProps> = ({ configuration, children }) => {
  if (!configuration) {
    return (
      <AppContainer>
        <FakePhone>
          <HomeSkeleton />
        </FakePhone>
      </AppContainer>
    )
  }

  return (
    <AppContainer>
      <FakePhone>{children}</FakePhone>
    </AppContainer>
  )
}

export default WebviewContainer
